import images from "./images";

const portfolio = [
  {
    id: 1,
    image: images.portfolio1,
    title: "Autonomous Vehicles",
    details: {
      date: "March 18, 2024",
      client: "Urban Mobility Tech",
      category: "Application",
      duration: "3 Months",
      location: "San Francisco, CA",
      website: "www.urbanmobilitytech.com",
      investment: "Project-based pricing",
      leadEngineer: "Samantha Woodrow"
    },
    paragraphs: [
      "This project focused on developing cutting-edge AI systems for autonomous vehicles to improve navigation and safety in complex traffic environments. The aim was to design an adaptive platform capable of real-time decision-making to handle urban driving challenges.",
      "Leveraging advanced sensor fusion, computer vision, and machine learning techniques, our team created models that detect obstacles, predict traffic patterns, and optimize route planning to ensure reliable and safe autonomous driving."
    ],
    gallery: [
      images.portfolio1Gallery1,
      images.portfolio1Gallery2,
      images.portfolio1Gallery3,
      images.portfolio1Gallery4,
      images.portfolio1Gallery5,
      images.portfolio1Gallery6,
    ],
    technologies: [
      "Sensor Fusion & Lidar Integration",
      "Computer Vision for Object Detection",
      "Deep Learning for Traffic Prediction",
      "Real-Time Autonomous Decision Making"
    ],
    challenges: [
      "Accurately Detecting and Classifying Obstacles",
      "Navigating Complex Urban Traffic Conditions",
      "Ensuring System Safety and Reliability"
    ],
    solutions: [
      "Developed Multi-Sensor Data Fusion Algorithms",
      "Trained Robust Deep Learning Models",
      "Implemented Safety Protocols and Fail-Safe Systems"
    ],
    results: [
      "Improved Autonomous Navigation Accuracy by 95%",
      "Successfully Passed Multiple Real-World Road Tests",
      "Received Positive Client Feedback for System Reliability"
    ]
  },
  {
    id: 2,
    image: images.portfolio2,
    title: "Robotic Arm",
    details: {
      date: "April 10, 2024",
      client: "Precision Robotics Inc.",
      category: "Automation",
      duration: "2 Months",
      location: "Austin, TX",
      website: "www.precisionrobotics.com",
      investment: "Fixed project fee",
      leadEngineer: "Michael Brown"
    },
    paragraphs: [
      "The Robotic Arm Automation project aimed to design and implement a highly precise robotic arm system for assembly line automation. Our goal was to enhance manufacturing efficiency by automating repetitive and precise tasks with minimal human intervention.",
      "Utilizing advanced control algorithms and sensor integration, the robotic arm was programmed for tasks such as part manipulation, welding, and quality inspection. The system featured real-time feedback loops to maintain accuracy and adapt to dynamic production needs."
    ],
    gallery: [
      images.portfolio2Gallery1,
      images.portfolio2Gallery2,
      images.portfolio2Gallery3,
      images.portfolio2Gallery4,
      images.portfolio2Gallery5,
      images.portfolio2Gallery6,
    ],
    technologies: [
      "Robotic Arm Kinematics and Dynamics",
      "Real-Time Sensor Feedback Systems",
      "Automation Control Algorithms",
      "Precision Actuators and Grippers"
    ],
    challenges: [
      "Achieving High Precision in Repetitive Tasks",
      "Integrating Multiple Sensors for Feedback",
      "Ensuring System Robustness in Industrial Settings"
    ],
    solutions: [
      "Implemented Advanced PID Control Loops",
      "Calibrated Multi-Sensor Fusion Systems",
      "Designed Durable and Adaptive Gripper Mechanisms"
    ],
    results: [
      "Increased Production Line Efficiency by 40%",
      "Reduced Error Rates in Assembly Tasks by 25%",
      "Received Client Praise for System Reliability and Flexibility"
    ]
  },
  {
    id: 3,
    image: images.portfolio3,
    title: "Video Surveillance",
    details: {
      date: "May 5, 2024",
      client: "SecureTech Solutions",
      category: "Security",
      duration: "1 Month",
      location: "San Francisco, CA",
      website: "www.securetechsolutions.com",
      investment: "Project-based pricing",
      leadEngineer: "Emily White"
    },
    paragraphs: [
      "This Video Surveillance Security project involved designing and deploying a state-of-the-art security camera system to monitor sensitive facilities and public spaces. The focus was on enhancing security with real-time monitoring and advanced analytics.",
      "The system integrated AI-powered video analytics to detect suspicious behavior, facial recognition, and automated alerts. High-resolution cameras were strategically placed to cover blind spots and ensure comprehensive surveillance coverage."
    ],
    gallery: [
      images.portfolio3Gallery1,
      images.portfolio3Gallery2,
      images.portfolio3Gallery3,
      images.portfolio3Gallery4,
      images.portfolio3Gallery5,
      images.portfolio3Gallery6,
    ],
    technologies: [
      "AI-Powered Video Analytics",
      "Facial Recognition Software",
      "High-Resolution IP Cameras",
      "Automated Security Alerts"
    ],
    challenges: [
      "Managing Large Volumes of Video Data",
      "Ensuring Real-Time Analytics and Alerts",
      "Maintaining Privacy and Data Security Compliance"
    ],
    solutions: [
      "Implemented Edge Computing for On-Site Data Processing",
      "Optimized AI Models for Speed and Accuracy",
      "Adhered to Industry Privacy Standards and Encryption"
    ],
    results: [
      "Enhanced Security Monitoring with 24/7 Real-Time Alerts",
      "Reduced False Positives by 30% with AI Analytics",
      "Improved Incident Response Time by 50%"
    ]
  },
  {
    id: 4,
    image: images.portfolio4,
    title: "Financial Data",
    details: {
      date: "April 10, 2024",
      client: "FinAnalytics Corp.",
      category: "Analysis",
      duration: "3 Weeks",
      location: "New York, NY",
      website: "www.finanalyticscorp.com",
      investment: "Fixed project cost",
      leadEngineer: "Michael Brown"
    },
    paragraphs: [
      "This Financial Data Analysis project involved processing large datasets from various financial markets to uncover trends, forecast risks, and provide actionable insights. The objective was to support strategic decision-making for investment portfolios.",
      "Our team used advanced statistical models and machine learning algorithms to analyze historical data, detect anomalies, and generate predictive reports. The solution improved the client's ability to make informed financial decisions under uncertainty."
    ],
    gallery: [
      images.portfolio4Gallery1,
      images.portfolio4Gallery2,
      images.portfolio4Gallery3,
      images.portfolio4Gallery4,
      images.portfolio4Gallery5,
      images.portfolio4Gallery6,
    ],
    technologies: [
      "Machine Learning for Predictive Analytics",
      "Statistical Data Modeling",
      "Big Data Processing Tools",
      "Interactive Data Visualization"
    ],
    challenges: [
      "Handling Incomplete and Noisy Data",
      "Integrating Multiple Data Sources",
      "Ensuring Accuracy of Predictive Models"
    ],
    solutions: [
      "Implemented Robust Data Cleaning Pipelines",
      "Developed Custom Data Integration Frameworks",
      "Applied Cross-Validation Techniques for Model Accuracy"
    ],
    results: [
      "Improved Forecast Accuracy by 25%",
      "Reduced Data Processing Time by 40%",
      "Enabled Proactive Risk Management Strategies"
    ]
  },
  {
    id: 5,
    image: images.portfolio5,
    title: "Virtual Gaming",
    details: {
      date: "May 5, 2024",
      client: "NextGen Games",
      category: "Application",
      duration: "4 Months",
      location: "San Francisco, CA",
      website: "www.nextgengames.com",
      investment: "Project-based pricing",
      leadEngineer: "Emily White"
    },
    paragraphs: [
      "This project involved developing an immersive virtual gaming platform powered by AI to create dynamic, adaptive gameplay experiences. Our goal was to push the boundaries of interactive entertainment using cutting-edge AI techniques.",
      "We integrated AI-driven NPC behavior, real-time environment adaptation, and procedural content generation to keep players engaged with personalized challenges. The platform supports multiplayer functionality and cross-device compatibility."
    ],
    gallery: [
      images.portfolio5Gallery1,
      images.portfolio5Gallery2,
      images.portfolio5Gallery3,
      images.portfolio5Gallery4,
      images.portfolio5Gallery5,
      images.portfolio5Gallery6,
    ],
    technologies: [
      "AI-Driven NPC Behavior",
      "Procedural Content Generation",
      "Real-Time Environment Adaptation",
      "Cross-Platform Multiplayer Support"
    ],
    challenges: [
      "Balancing AI Complexity with Performance",
      "Ensuring Seamless Multiplayer Synchronization",
      "Creating Adaptive Game Environments"
    ],
    solutions: [
      "Optimized AI Algorithms for Low Latency",
      "Implemented Efficient Network Protocols",
      "Developed Modular Environment Components"
    ],
    results: [
      "Enhanced Player Engagement and Retention",
      "Positive User Feedback on Dynamic Gameplay",
      "Increased Platform User Base by 30%"
    ]
  },
  {
    id: 6,
    image: images.portfolio6,
    title: "Warehouse Automation",
    details: {
      date: "June 12, 2024",
      client: "LogiTech Solutions",
      category: "Automation",
      duration: "3 Months",
      location: "Chicago, IL",
      website: "www.logitechsolutions.com",
      investment: "Custom pricing based on scale",
      leadEngineer: "Michael Brown"
    },
    paragraphs: [
      "This project focused on implementing a comprehensive warehouse automation system to optimize inventory management and streamline logistics operations. Our goal was to reduce manual labor and improve accuracy in stock handling.",
      "We developed robotic picking systems, automated sorting conveyors, and AI-driven inventory tracking to maximize efficiency. Integration with existing warehouse management software ensured seamless data flow and real-time monitoring."
    ],
    gallery: [
      images.portfolio6Gallery1,
      images.portfolio6Gallery2,
      images.portfolio6Gallery3,
      images.portfolio6Gallery4,
      images.portfolio6Gallery5,
      images.portfolio6Gallery6,
    ],
    technologies: [
      "Robotic Picking Systems",
      "Automated Sorting Conveyors",
      "AI-Driven Inventory Tracking",
      "Warehouse Management Software Integration"
    ],
    challenges: [
      "Ensuring System Scalability",
      "Integrating with Legacy Software",
      "Maintaining Real-Time Data Accuracy"
    ],
    solutions: [
      "Modular System Architecture",
      "Custom API Development for Integration",
      "Robust Data Synchronization Protocols"
    ],
    results: [
      "Increased Operational Efficiency by 40%",
      "Reduced Manual Errors by 60%",
      "Shortened Order Fulfillment Time Significantly"
    ]
  }

];

export default portfolio;